(function () {
  function init(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-product-card]'));
    var list = root.querySelector('[data-pg-list]');

    if (root.dataset.sortPriceAsc === 'true' && list) {
      var price = function (card) {
        var value = parseFloat(card.dataset.productPrice);
        return isNaN(value) ? Infinity : value;
      };
      cards = cards
        .map(function (card, index) {
          return { card: card, index: index };
        })
        .sort(function (a, b) {
          var diff = price(a.card) - price(b.card);
          return diff === 0 || isNaN(diff) ? a.index - b.index : diff;
        })
        .map(function (item) {
          return item.card;
        });
      cards.forEach(function (card) {
        list.appendChild(card);
      });
    }

    var filters = Array.prototype.slice.call(root.querySelectorAll('[data-pg-filter]'));
    var moreBtn = root.querySelector('[data-pg-more]');
    var empty = root.querySelector('[data-pg-empty]');
    var count = root.querySelector('[data-pg-count]');
    var pageSize = parseInt(root.dataset.pageSize, 10) || 6;
    var step = parseInt(root.dataset.step, 10) || pageSize;
    var visible = pageSize;
    var active = null;

    function matches(card) {
      if (!active) return true;

      if (active.dataset.type === 'gift') {
        var handle = active.dataset.handle;
        return !!handle && (card.dataset.packGifts || '').indexOf(' ' + handle + ' ') !== -1;
      }

      var value = parseFloat(
        active.dataset.type === 'discount' ? card.dataset.packDiscount : card.dataset.productPrice
      );
      if (isNaN(value)) return false;
      var min = parseFloat(active.dataset.min);
      var max = parseFloat(active.dataset.max);
      return (isNaN(min) || value >= min) && (isNaN(max) || value <= max);
    }

    function render() {
      var matched = cards.filter(matches);
      cards.forEach(function (card) {
        card.hidden = true;
      });
      matched.forEach(function (card, i) {
        card.hidden = i >= visible;
      });
      if (moreBtn) moreBtn.hidden = matched.length <= visible;
      if (empty) empty.hidden = matched.length > 0;
      if (count) count.textContent = matched.length + (matched.length === 1 ? ' resultado' : ' resultados');
    }

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        active = active === btn ? null : btn;
        filters.forEach(function (b) {
          var on = b === active;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        visible = pageSize;
        render();
      });
    });

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        visible += step;
        render();
      });
    }

    render();
  }

  function initBack(root) {
    var back = root.querySelector('.pack-grid__back');
    if (!back || back.dataset.pgBackBound) return;
    back.dataset.pgBackBound = 'true';
    // volta para a página de onde o usuário veio (home, vitrine...); sem origem, usa o link configurado
    back.addEventListener('click', function (event) {
      var ref = document.referrer;
      if (!ref || window.history.length < 2) return;
      try {
        var from = new URL(ref);
        if (from.origin !== window.location.origin || from.pathname === window.location.pathname) return;
      } catch (e) {
        return;
      }
      event.preventDefault();
      window.history.back();
    });
  }

  function boot() {
    document.querySelectorAll('[data-pack-grid]').forEach(init);
    document.querySelectorAll('[data-pack-grid]').forEach(initBack);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
